import { createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-176f2489"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dialog-title" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text" }, " 修改基本信息 ", -1 /* HOISTED */))
const _hoisted_3 = { class: "dialog-content" }
const _hoisted_4 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "model-value": $props.baseVisible,
    width: "500",
    "show-close": false,
    "destroy-on-close": "",
    "before-close": $setup.handleClose
  }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_el_icon, {
          size: "18",
          style: {"cursor":"pointer"},
          onClick: $setup.handleClose
        }, {
          default: _withCtx(() => [
            _createVNode($setup["CloseBold"])
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, { onClick: $setup.handleClose }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: $setup.submit
        }, {
          default: _withCtx(() => [
            _createTextVNode("确认")
          ]),
          _: 1 /* STABLE */
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          ref: "baseFormRef",
          model: $setup.baseForm,
          rules: $setup.baseRules,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: "应用名",
              prop: "appName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: $setup.baseForm.appName,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.baseForm.appName) = $event)),
                  clearable: "",
                  placeholder: "请输入应用名称"
                }, null, 8 /* PROPS */, ["modelValue"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_form_item, {
              label: "应用描述",
              prop: "appDescription"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: $setup.baseForm.appDescription,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.baseForm.appDescription) = $event)),
                  clearable: "",
                  placeholder: "请输入应用描述"
                }, null, 8 /* PROPS */, ["modelValue"])
              ]),
              _: 1 /* STABLE */
            }),
            _createVNode(_component_el_form_item, { label: "开启VoIP推送" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  modelValue: $setup.baseForm.hasVOIP,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.baseForm.hasVOIP) = $event))
                }, null, 8 /* PROPS */, ["modelValue"])
              ]),
              _: 1 /* STABLE */
            })
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["model"])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["model-value"]))
}